import { CheckCircle2, Clock3, FilePlus2, History, Inbox } from 'lucide-react';
import { Button } from '../ui/button';

export function AdminWorkflowPanel({
  title,
  draftCount,
  publishedCount,
  submissionCount,
  onCreate,
  onOpenHistory,
  onOpenSubmissions,
}) {
  return (
    <section className="mb-6 rounded-3xl border border-white/10 bg-white/[0.03] p-5 md:p-6">
      <div className="flex flex-col gap-6 lg:flex-row lg:items-start lg:justify-between">
        <div className="space-y-3">
          <div className="text-xs uppercase tracking-[0.28em] text-[#E11D2E]">Editor Workspace</div>
          <h2 className="text-2xl font-black font-heading text-white tracking-tight">{title}</h2>
          <p className="max-w-2xl text-sm text-white/65">
            Рабочий сценарий: создать черновик, проверить контент и slug, опубликовать, затем убедиться в истории изменений и входящих заявках.
          </p>
        </div>
        <div className="flex flex-wrap gap-3">
          {onCreate && (
            <Button onClick={onCreate} className="rounded-full bg-[#E11D2E] text-white hover:bg-[#E11D2E]/90">
              <FilePlus2 className="mr-2 h-4 w-4" />
              New Draft
            </Button>
          )}
          <Button onClick={onOpenHistory} className="rounded-full bg-white/10 text-white hover:bg-white/20">
            <History className="mr-2 h-4 w-4" />
            History
          </Button>
          <Button onClick={onOpenSubmissions} className="rounded-full bg-white/10 text-white hover:bg-white/20">
            <Inbox className="mr-2 h-4 w-4" />
            Submissions
          </Button>
        </div>
      </div>

      <div className="mt-5 grid grid-cols-1 gap-4 md:grid-cols-3">
        <MetricCard
          icon={Clock3}
          title="Drafts"
          value={draftCount}
          description="Контент, который ещё не виден публично"
        />
        <MetricCard
          icon={CheckCircle2}
          title="Published"
          value={publishedCount}
          description="Контент, доступный на публичном сайте"
        />
        <MetricCard
          icon={Inbox}
          title="Submissions"
          value={submissionCount}
          description="Актуальные входящие заявки и формы"
        />
      </div>
    </section>
  );
}

function MetricCard({ icon: Icon, title, value, description }) {
  return (
    <div className="rounded-2xl border border-white/10 bg-black/20 p-4">
      <div className="flex items-center gap-2 text-white/70">
        <Icon className="h-4 w-4 text-[#E11D2E]" />
        <span className="text-sm">{title}</span>
      </div>
      <div className="mt-3 text-3xl font-black text-white">{value}</div>
      <div className="mt-1 text-xs uppercase tracking-widest text-white/40">{description}</div>
    </div>
  );
}
